import gql from 'graphql-tag';

export default gql`
  mutation updateAccount($accountId: ID!, $name: String) {
    account: updateAccount(accountId: $accountId, name: $name) {
      id
    }
  }
`;
